module.exports = __webpack_public_path__ + "static/media/error-fallback-image.3098f2c4.svg";